import React, { useState, useEffect } from 'react';
import { Col, Row, notification } from 'antd';
import { useNavigate } from 'react-router-dom';
import AcesseOSite from '../sharedComponents/AcesseOSite/AcesseOSite';
import Bulas from '../sharedComponents/Bulas/Bulas';
import Cotacao from '../sharedComponents/Cotacao/Cotacao';
import GreetingsComponent from '../../components/GreetingsComponent/GreetingsComponent';
import RevistaCoopercitrus from '../sharedComponents/RevistaCoopercitrus/RevistaCoopercitrus';
import { getUserPermissions } from '../../utils/users';
import './Home.scss';
import {
  isSuperAgentError, get, RequestWrapper, ResponseWrapper,
} from '../../dataSource/requests';
import { API_URL } from '../../utils/constants';

const Home = (): JSX.Element => {
  interface BannerInfo {
    url: string;
    link: string;
  }

  const navigate = useNavigate();

  const [banner, setBanner] = useState<BannerInfo | null>(null);

  const showNotification = (type: string): void => {
    const notificationArguments = {
      message: 'Notification Title',
      description: 'Description',
    };

    switch (type) {
      case 'ErrorBanner':
        notificationArguments.message = 'Erro no Banner';
        notificationArguments.description = 'Ocorreu um erro ao carregar as informações sobre o Banner.';
        notification.error(notificationArguments);
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    const getBanner = async (): Promise<void> => {
      let response: ResponseWrapper | undefined;
      let responseError: ResponseWrapper | undefined;
      let genericError: Error | undefined;

      const requestReference: RequestWrapper = get({
        url: '/banner/getBannerParameters',

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      try {
        response = await requestReference;
      } catch (error) {
        if (isSuperAgentError(error)) {
          responseError = error.response;
        } else {
          genericError = error as Error;
        }
      }

      switch (true) {
        case (response?.body?.code === 12000):
        case (response?.body?.code === 12001):
          // "Banner parameters got successfully", 12000
          // "Banner parameters got successfully - No display enabled banner", 12001

          if (
            response?.body.bannerParametersOutput != null
            && response?.body.bannerParametersOutput.imageUrl != ''
            && response?.body.bannerParametersOutput.imageUrl != null
          ) {
            const imageUrl = `${API_URL}${response?.body.bannerParametersOutput.imageUrl}`;
            setBanner({
              url: imageUrl,
              link: response?.body.bannerParametersOutput.link,
            });
          }
          break;

        case (responseError?.body?.code === -4001):
          // "You must be authenticated to perform this operation", -4001
          break;

        case (genericError?.message?.includes('has been aborted')):
          // dont show anything when request is aborted
          break;

        default:
          showNotification('ErrorBanner');
          break;
      }
    };

    getBanner();
  }, []);

  return (
    <div className="Home">
      {
        banner != null
          ? (
            <div className="banner_div">
              <a href={banner.link} target="_blank" rel="noreferrer">
                <img
                  alt=" "
                  className="banner"
                  src={banner.url}
                />
              </a>
            </div>
          ) : (
            <div></div>
          )
      }
      <div className="default-page-title">Início</div>
      <Row className="marginsNameBp">
        <Col
          xs={{ span: 24 }}
          lg={{ span: 24 }}
        >
          <GreetingsComponent />
        </Col>
      </Row>
      <Row
        className="Home__row"
        type="flex"
        justify="center"
        gutter={16}
      >
        {
          ((getUserPermissions() || []).includes('Acesse o site')) ? (
            <Col className="Home__column" xs={24} sm={18} md={12} lg={6}>
              <AcesseOSite />
            </Col>
          ) : null
        }

        {
          ((getUserPermissions() || []).includes('Bulas')) ? (
            <Col className="Home__column" xs={24} sm={18} md={12} lg={6}>
              <Bulas />
            </Col>
          ) : null
        }

        {
          ((getUserPermissions() || []).includes('Revista Coopercitrus')) ? (
            <Col className="Home__column" xs={24} sm={18} md={12} lg={6}>
              <RevistaCoopercitrus />
            </Col>
          ) : null
        }

        {
          ((getUserPermissions() || []).includes('Cotações')) ? (
            <Col className="Home__column" xs={24} sm={18} md={12} lg={6}>
              <Cotacao />
            </Col>
          ) : null
        }
      </Row>
    </div>
  );
};

Home.propTypes = {};
Home.defaultProps = {};

export default Home;
